import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Input, Button } from "components/common/common";
import s from "./Login.module.css";
import { loginUser } from "store/authSlice";

const Login = () => {
	const [login, setLogin] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		setError(null);

		try {
			const resultAction = await dispatch(loginUser({ login, password }));
			// Явная проверка на ошибку
			if (loginUser.rejected.match(resultAction)) {
				throw new Error(resultAction.payload);
			}
			navigate("/admin");
		} catch (err) {
			// Более надежное получение сообщения об ошибке
			setError(err.message || "Произошла ошибка при авторизации");
			console.error("Login error:", err);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className={s.loginContainer}>
			<div className={s.loginForm}>
				<h1>Авторизация</h1>
				<form onSubmit={handleSubmit}>
					<Input
						label="Логин"
						value={login}
						onChange={setLogin}
						placeholder="Введите ваш логин"
						required
					/>
					<Input
						type="password"
						label="Пароль"
						value={password}
						onChange={setPassword}
						placeholder="Введите ваш пароль"
						required
					/>
					{error && <div className={s.error}>{error}</div>}
					<Button
						type="submit"
						label={isLoading ? "Вход..." : "Войти"}
						disabled={isLoading}
						variant="primary"
						fullWidth
					/>
				</form>
			</div>
		</div>
	);
};

export default Login;
